module.exports = __webpack_public_path__ + "static/media/Segment5.7bedeac6.jpg";